import React from 'react';
import { Stack, Typography } from '@mui/material';

type DocumentQuestionViewProps = {
  documentTypes: string[];
  isMandatory: boolean | undefined;
};

export const DocumentQuestionView: React.FC<DocumentQuestionViewProps> = ({
  documentTypes,
  isMandatory
}) => {
  return (
    <Stack gap="10px" flex="1">
      <Typography variant="captions">Document request</Typography>
      <Stack spacing={1}>
        {documentTypes.map((doc, index) => (
          <Typography key={index} variant="summary">
            {doc}
          </Typography>
        ))}
      </Stack>
      <Typography>
        {isMandatory
          ? 'The candidate must provide these documents.'
          : 'These documents are optional.'}
      </Typography>
    </Stack>
  );
};
